import { render } from "./Layout2.vue?vue&type=template&id=1b22f8b2&scoped=true&ts=true"
import script from "./Layout2.vue?vue&type=script&lang=ts"
export * from "./Layout2.vue?vue&type=script&lang=ts"

import "./Layout2.vue?vue&type=style&index=0&id=1b22f8b2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b22f8b2"]])

export default __exports__